import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUkmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.86 3.52A8.967 8.967 0 0 0 .31 6.653h4.682L1.86 3.521Zm15.83 3.132a8.968 8.968 0 0 0-1.55-3.131l-3.132 3.131h4.682ZM.31 11.348a8.969 8.969 0 0 0 1.55 3.131l3.132-3.131H.31ZM14.48 1.86A8.968 8.968 0 0 0 11.347.31v4.682l3.131-3.132ZM3.52 16.14c.92.706 1.98 1.24 3.132 1.55v-4.682l-3.131 3.131ZM6.652.31a8.968 8.968 0 0 0-3.131 1.55l3.131 3.132V.31Zm4.696 17.38a8.968 8.968 0 0 0 3.131-1.55l-3.131-3.132v4.682Zm1.66-6.342 3.132 3.131a8.968 8.968 0 0 0 1.55-3.131h-4.682Z",
			fill: "#2839BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.924 7.826h-7.75V.076a9.089 9.089 0 0 0-2.348 0v7.75H.076a9.09 9.09 0 0 0 0 2.348h7.75v7.75a9.094 9.094 0 0 0 2.348 0v-7.75h7.75a9.093 9.093 0 0 0 0-2.348Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m11.348 11.348 4.016 4.016c.185-.185.36-.378.529-.578l-3.438-3.438h-1.107Zm-4.696 0-4.016 4.016c.185.184.378.36.578.529l3.438-3.439v-1.106Zm0-4.696L2.636 2.636a9.02 9.02 0 0 0-.529.578l3.438 3.438h1.107Zm4.696.001 4.016-4.017a9.001 9.001 0 0 0-.578-.529l-3.438 3.439v1.107Z",
			fill: "#D80027"
		})
	]
});
const ForwardRef = forwardRef(SvgUkmin);
export { ForwardRef as ReactComponent };
